import { addTo } from '../../../util/index.js';
import { isCreditNote } from '../../vouchers/matcher.js';
import { addDistribution, balance, payTarget } from './allocation.js';
import { consume } from './ledger.js';
import { catchUp, noteAppendAt } from './timeline.js';
const jointAllocation = (source, target, amount, correction) => ({
    sourceCaseVoucherId: source.caseVoucherId,
    targetCaseId: target.caseState.caseId,
    targetCaseVoucherId: target.caseVoucherId,
    amount,
    correction,
});
export const mirror = async (run, source, at, paidByTarget) => {
    for (const [target, amount] of paidByTarget) {
        for (const counterpart of run.counterparts.get(target.associationId) ??
            []) {
            if (counterpart.caseState === target.caseState) {
                continue;
            }
            const caseState = counterpart.caseState;
            await catchUp(caseState, at);
            const limit = Math.min(amount, Math.max(0, balance(counterpart)));
            // Oldest first on the other case, as everywhere (D9).
            const paid = limit > 0 ? payTarget(counterpart, limit) : 0;
            if (paid > 0) {
                addDistribution(counterpart, source.caseVoucherId, paid, source.date, undefined);
            }
            noteAppendAt(caseState, at);
            run.jointAllocations.push(jointAllocation(source, counterpart, paid, false));
        }
    }
};
// Pins what the replay chose on the source's own case, as its mirrors are
// pinned on the others.
export const pinOwn = (run, source, paidByTarget) => {
    for (const [target, amount] of paidByTarget) {
        run.jointAllocations.push(jointAllocation(source, target, amount, false));
    }
};
// A credit note's only purpose is to correct: what it pays of joint debt is
// replayed as a correction, on its own case and every other (D11).
export const isJointCreditNote = (entry) => entry.jointSource && isCreditNote(entry.voucher);
// Pins the correction a joint credit note makes on its own case, as its
// mirrors pin it on the others.
export const pinOwnCorrection = (run, source, target, amount) => {
    run.jointAllocations.push(jointAllocation(source, target, amount, true));
};
export const mirrorCorrection = (run, source, target, amount) => {
    const associationId = target.associationId;
    if (!source.jointSource || associationId == null) {
        return;
    }
    for (const counterpart of run.counterparts.get(associationId) ?? []) {
        if (counterpart.caseState === target.caseState) {
            continue;
        }
        const ledger = counterpart.ledger;
        let applied = amount;
        if (counterpart.kind === 'interest') {
            ledger.waiver += amount;
        }
        else {
            applied = consume(ledger, amount);
        }
        addTo(counterpart.caseState.corrected, counterpart.caseVoucherId, applied);
        if (applied > 0) {
            addDistribution(counterpart, source.caseVoucherId, applied, counterpart.date, undefined);
        }
        run.jointAllocations.push(jointAllocation(source, counterpart, applied, true));
    }
};
//# sourceMappingURL=joint.js.map